'use client';

import { useRouter } from 'next/navigation';
import { Fragment } from 'react';
import LegacyDangerIconWithShadow from 'src/app/_components/icons/legacy/LegacyDangerIconWithShadow';
import { useAppDispatch } from 'src/store/client/config';
import { modalActions } from 'src/store/client/slices/modalSlice';

import ModalButton from '@/app/(football)/[team]/_components/common/ModalButton';

export type VerifyCodeErrorStatusCode =
  | '3001'
  | '3002'
  | '3003'
  | '3004'
  | '3005'
  | '3006'
  | '3007'
  | '3008'
  | '3009'
  | '3010'
  | '3011';

const SIMILAR_CODE_EXAMPLE = [
  ['5-S', '2-Z', '6-G', '0-O'],
  ['8-B', 'U-V', '0-Q'],
];

interface CodeVerificationFailModalProps {
  statusCode: VerifyCodeErrorStatusCode;
}

export default function CodeVerificationFailModal({ statusCode = '3003' }: CodeVerificationFailModalProps) {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const handleCloseModal = () => dispatch(modalActions.closeModal());
  const handleRouteToQna = () => {
    router.push('/support/qna/list');
    handleCloseModal();
  };

  return (
    <div className="flex max-h-[480px] w-[320px] flex-col items-center rounded-lg bg-g-00 px-5 py-6">
      {/* 아이콘 */}
      <div className="mb-5 flex items-center justify-center">
        <LegacyDangerIconWithShadow
          size={56}
          foreground="var(--color-modal-icon)"
          background="#E8E8E8"
          gradient={{ from: '#E9E9E9', to: '#DADADA' }}
        />
      </div>

      {/* 바디 */}
      <div className="flex w-full flex-col items-center gap-2">
        {/* 타이틀 */}
        <p className="typo-body-1 text-center text-g-90">
          {statusCode === '3001' ? '코드가 이미 사용되었어요.' : '코드를 다시 확인해주세요.'}
        </p>

        {/* 디스크립션 */}
        <p className="typo-body-5 text-center text-g-60">
          {statusCode === '3001' ? (
            <>
              다시 코드를 확인해주시고
              <br />
              문제가 있다면 1:1 문의를 통해 알려주세요.
            </>
          ) : (
            <>
              일부 글자 및 숫자가 유사해 보일 수 있으니,
              <br />
              한번 더 확인해주세요.
            </>
          )}
        </p>

        {/* 유사 코드 예시 */}
        <div className="mt-2 flex w-full flex-col items-center gap-2 rounded-lg bg-g-10 px-4 py-3">
          <span className="typo-body-5 text-g-90">유사코드 예시</span>
          {SIMILAR_CODE_EXAMPLE.map((row, rowIndex) => (
            <div key={rowIndex} className="flex items-center gap-3">
              {row.map((item, index) => (
                <Fragment key={index}>
                  <span className="typo-body-5 text-g-50">{item}</span>
                  {index !== row.length - 1 && <span className="h-[3px] w-[3px] rounded-full bg-g-50" />}
                </Fragment>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* 버튼 영역 */}
      <div className="mt-6 flex w-full items-center gap-2">
        <ModalButton
          variant="secondary"
          onClick={handleRouteToQna}
        >
          1:1문의
        </ModalButton>
        <ModalButton
          variant="primary"
          onClick={handleCloseModal}
        >
          확인
        </ModalButton>
      </div>
    </div>
  );
}
